export const namespaced = true

const getDefaultState = () => ({
	visible: false,
	title: '',
	message: '',
	confirmText: '',
	cancelText: '',
	type: 'info', // 'info' | 'danger'
	payload: null
})

export const state = () => getDefaultState()

export const getters = {
	visible: state => state.visible,
	title: state => state.title,
	message: state => state.message,
	confirmText: state => state.confirmText,
	cancelText: state => state.cancelText,
	type: state => state.type,
	payload: state => state.payload
}

export const mutations = {
	OPEN_MODAL(state, { title, message, confirmText, cancelText, type }) {
		state.visible = true
		state.title = title
		state.message = message
		state.confirmText = confirmText
		state.cancelText = cancelText
		state.type = type ?? 'info'
	},
	SET_PAYLOAD(state, { payload }) {
		state.payload = payload
	},
	CLOSE_MODAL(state) {
		Object.assign(state, getDefaultState())

		if (process.client) {
			window.dispatchEvent(new CustomEvent('modal:closed'))
		}
	}
}

export const actions = {
	open({ commit }, payload) {
		commit('OPEN_MODAL', payload)
		commit('SET_PAYLOAD', payload)
	},
	close({ commit }) {
		commit('CLOSE_MODAL')
	}
}
